import React from 'react';
import {
  Tool,
  type ToolArgsWithController,
  type ToolbarSubmenuProps,
} from '@aha-app/aha-editor-v2';
import classNames from 'classnames';
import ToolInsertNewWhiteboard from './ToolInsertNewWhiteboard';
import ToolInsertExistingWhiteboard from './ToolInsertExistingWhiteboard';

const WhiteboardOptions: React.FC<ToolbarSubmenuProps> = ({
  editor,
  controller,
  tool,
  isSubmenu,
}) => {
  return (
    <aha-menu submenu={isSubmenu}>
      <div slot='control'>
        <i className={classNames('fa-fw', tool.iconClass)} />
        {isSubmenu && tool.label}
      </div>
      <aha-menu-content>
        <aha-menu-item
          onClick={() => {
            ToolInsertNewWhiteboard.action({
              editor,
              controller,
            });
          }}
        >
          New whiteboard
        </aha-menu-item>
        <aha-menu-item
          onClick={() => {
            ToolInsertExistingWhiteboard.action({
              editor,
              controller,
            });
          }}
        >
          Existing whiteboard
        </aha-menu-item>
      </aha-menu-content>
    </aha-menu>
  );
};

class ToolInsertWhiteboard extends Tool {
  static toolName = 'Whiteboard';
  static iconClass = 'fa-regular fa-shapes';

  static available({ controller }: ToolArgsWithController): boolean {
    return Boolean(controller.ahaEditor.hasPlugin('embeddedWhiteboard'));
  }

  static toolbarSubmenu() {
    return WhiteboardOptions;
  }
}

export default ToolInsertWhiteboard;
